<template>
  <div>
    <!-- <p class="c-inner-title">客户管理</p> -->
    <div class="auto">
      <page-title title="客户管理" icon="fa-windows"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-button type="primary" @click="handleSubmit" size="small">新增客户</el-button>
          </el-row>
          <el-table
            :data="list"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column
              prop="cn_name"
              label="中文名称">
            </el-table-column>
            <el-table-column
              prop="en_name"
              label="英文名称">
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
              <el-button @click="handleSubmit(scope.$index)" type="primary" size="small">修改</el-button>
            </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="新增事件" :modal-append-to-body="false" :visible.sync="formVisible">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px" size="small">
        <el-form-item prop="cn_name" label="中文名称">
          <el-input v-model.trim="form.cn_name"></el-input>
        </el-form-item>
        <el-form-item prop="en_name" label="英文名称">
          <el-input v-model.trim="form.en_name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleExit">取消</el-button>
        <el-button size="small" type="primary" @click="submit" :loading="btnLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {System} from '@/model'
export default {
  data () {
    return {
      list: [],
      formVisible: false,
      form: {
        cn_name: '',
        en_name: ''
      },
      rules: {
        cn_name: [
          { required: true, message: '中文名称不能为空！', trigger: 'blur' }
        ],
        en_name: [
          { required: true, message: '英文名称不能为空！', trigger: 'blur' }
        ]
      },
      cloneForm: {},
      loading: false,
      btnLoading: false,
      filter: {
        page: '1',
        limit: '10'
      },
      total: 0,
      updateStatus: false
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    handleChangeFilter () {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/system/system/customer', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.index()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    async index () {
      this.loading = true
      let res = await System.index(this.filter)
      this.loading = false
      if (res['err_code']) {
        this.$message.error(res['err_msg'])
      } else {
        this.list = res['data']['list']
        this.total = res['data']['total']
      }
    },
    handleSubmit (index) {
      this.updateStatus = false
      let row = Object.assign({}, this.cloneForm)
      if (index > -1) {
        this.updateStatus = true
        row = Object.assign({}, this.list[index])
        delete row['create_time']
      }
      this.form = row
      this.formVisible = true
    },
    handleExit () {
      this.formVisible = false
    },
    async submit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid && this.form.cn_name.trim() && this.form.en_name.trim()) {
          this.btnLoading = true
          let res = await System.doSubmit(this.form)
          this.btnLoading = false
          if (res['err_code']) {
            this.$message.error(res['err_msg'])
          } else {
            this.$message({
              message: '操作成功！',
              type: 'success'
            })
            this.formVisible = false
            if (!this.updateStatus) {
              this.resetFilter()
            }
            this.index()
          }
        }
      })
    }
  },
  created () {
    this.cloneForm = Object.assign({}, this.form)
    this.queryToFilter()
  }
}
</script>
